<template>
  <!--
    地块选择弹窗组件
    - 展示地块卡片列表，支持多选
    - 通过 visible 控制显示，landList 提供地块数据，selectedLands 回显已选
    - 选择后通过 land-selected 事件传递选中地块
  -->
  <el-dialog title="选择流转地块" :visible.sync="dialogVisible" width="700px"  @close="handleClose" append-to-body>
    <div class="land-card-list">
      <!-- 有地块数据时循环渲染地块卡片 -->
      <template v-if="landList && landList.length > 0">
        <div v-for="land in landList" :key="land.id" class="land-card" @click="handleLandClick(land)">
          <!-- 地块图片，优先展示卫星图，若无则用现场图片 -->
          <img class="land-img" :src="landImages[land.xmbh] || getFirstImage(land.xctp)" alt="地块图片" />
          <div class="land-info">
            <div class="land-title">{{ land.xmmc }}</div>
            <div class="land-tags">
              <!-- 地块面积、类型、流转年限标签 -->
              <el-tag size="mini" type="success">{{ land.zcmj }}亩</el-tag>
              <el-tag size="mini" type="info">{{ getCqlxName(land.cqlxbh) }}</el-tag>
              <el-tag size="mini" type="warning">{{ land.lznx }}年</el-tag>
            </div>
            <div class="land-price">总价：<span class="price">¥{{ land.gpjg || '0' }}</span></div>
          </div>
          <!-- 复选框，显示选中状态 -->
          <div class="checkbox-container" @click.stop>
            <el-checkbox 
              class="land-checkbox" 
              :value="isSelected(land)" 
              @input="checked => toggleSelection(land, checked)"
              @click.stop>
            </el-checkbox>
          </div>
        </div>
      </template>
      
      <!-- 没有地块数据时显示提示信息 -->
      <div v-else class="empty-state">
        <div class="empty-icon">📍</div>
        <div class="empty-text">暂无在有效期内的流转土地</div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="confirmSelection">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {findListByXmbh,findOneByXmbh} from '@/api/add'
export default {
  // 组件属性说明
  props: {
    // 弹窗显示控制
    visible: Boolean,
    // 回显已选地块数组
    selectedLands: Array,
    // 地块列表数据
    landList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      // 内部控制弹窗显示的变量
      dialogVisible: false,
      CoordinateList:[],// 存储选中地块的坐标
      // 当前已选地块数组
      selected: [],
      // 存储本地 types 数组（地块类型字典）
      types: [],
      // 存储每个地块的图片URL（包括卫星图）
      landImages: {}
    }
  },
  mounted() {
    console.log('LandSelectDialog mounted, props:', {
      visible: this.visible,
      selectedLands: this.selectedLands,
      landList: this.landList
    });
    
    // 初始化时从 localStorage 获取地块类型字典 types
    const types = localStorage.getItem('types');
    if (types) {
      try {
        this.types = JSON.parse(types);
      } catch (e) {
        this.types = [];
      }
    }
    
    // 确保初始状态正确
    this.dialogVisible = this.visible;
    // console.log('Initial dialogVisible set to:', this.dialogVisible);
  },
  watch: {
    // 监听父组件传入的visible，同步到内部dialogVisible
    visible: {
      handler(val) {
        // console.log('LandSelectDialog received visible change:', val);
        this.dialogVisible = val;
        if (val) {
          // 回显：拷贝 selectedLands
          this.selected = this.selectedLands ? this.selectedLands.map(item => ({ ...item })) : [];
          // console.log('Dialog should be visible now, dialogVisible:', this.dialogVisible);
          // console.log('回显的已选地块:', this.selected);
        }
      },
      immediate: true
    },
    // 监听地块列表变化，预加载地块图片
    landList: {
      handler(newList) {
        if (newList && newList.length > 0) {
          this.loadLandImages(newList);
        }
      },
      immediate: true
    }
  },
  methods: {
    // 预加载所有地块的图片（优先卫星图）
    async loadLandImages(landList) {
      if (!landList || landList.length === 0) return;
      
      // 并行加载所有地块的图片
      const imagePromises = landList.map(async (land) => {
        if (land.xmbh && !this.landImages[land.xmbh]) {
          try {
            const imageUrl = await this.getEnhancedImage(land);
            // 使用 Vue.set 确保响应式更新
            this.$set(this.landImages, land.xmbh, imageUrl);
          } catch (error) {
            console.warn(`加载地块 ${land.xmbh} 图片失败:`, error);
            // 如果获取失败，使用默认现场图片
            this.$set(this.landImages, land.xmbh, this.getFirstImage(land.xctp));
          }
        }
      });
      
      // 等待所有图片加载完成
      await Promise.all(imagePromises);
      console.log('所有地块图片加载完成:', this.landImages);
    },
    // 判断地块是否已选
    isSelected(land) {
      // console.log(JSON.parse(JSON.stringify(land)),'查看获取的数据')
      return this.selected.some(item => item.xmbh === land.xmbh);
    },
    // 切换地块选中状态
   async toggleSelection(land, checked,) {
      // console.log(land,checked,'查看12345')
      const idx = this.selected.findIndex(item => item.xmbh === land.xmbh);
      
      if (checked) {
        // 选中地块
        if (idx === -1) {
          // 检查行政区编号是否一致
          if (this.selected.length > 0) {
            const firstLandXzqbh = this.selected[0].xzqbh;
            if (land.xzqbh !== firstLandXzqbh) {
              this.$message.warning('请选择同一个村镇的地块');
              // 强制重新渲染以重置复选框状态
              this.$forceUpdate();
              return; // 阻止选择
            }
          }
          
          // console.log(`地块 ${land.xmmc} 不在已选列表中，添加到列表`);
          this.selected.push({ ...land });
          let res =await findListByXmbh({xmbh:land.xmbh})
          this.CoordinateList.push(...res.data)
        }
      } else {
        // 取消选中地块
        if (idx > -1) {
          // console.log(`取消选中地块 ${land.xmmc}`);
          this.selected.splice(idx, 1);
          this.CoordinateList.splice(idx,1)
          // this.$message.info(`已取消选择地块 ${land.xmmc}`);
        }
      }
    },
    
    // 确认选择，向父组件传递选中地块
    confirmSelection() {
      // console.log('确认选择，当前已选地块数量:', this.selected.length);
      
      // if (this.selected.length === 0) {
      //   this.$message.warning('请至少选择一个地块');
      //   return;
      // }
      
      // console.log('最终选择的地块:', this.selected);
      this.$message.success(`已选择 ${this.selected.length} 个地块`);

      // 传递地块对象数组和CoordinateList
      this.$emit('land-selected', { lands: this.selected, coordinates: this.CoordinateList });
      this.handleClose();
    },
    
    // 关闭弹窗，通知父组件
    handleClose() {
      // console.log('关闭地块选择弹窗，清理状态');
      // 先关闭内部弹窗
      this.dialogVisible = false;
      // 清理数据
      this.selected = [];
      this.CoordinateList = [];
      // 清理图片缓存
      this.landImages = {};
      // 通知父组件关闭弹窗
      this.$emit('update:visible', false);
      this.$emit('close');
    },
    
    // 根据 bh 查找 types 数组中的 name 或 lx 字段
    getCqlxName(bh) {
      if (!this.types || !Array.isArray(this.types)) return bh;
      const found = this.types.find(item => item.bh == bh);
      return found ? (found.name || found.lx || bh) : bh;
    },
    
    // 从 xctp JSON 对象中获取第一张图片的 URL
    getFirstImage(xctp) {
      try {
        // 如果 xctp 不存在，返回默认图片
        if (!xctp) {
          return require('@/assets/imgs/21.png');
        }
        
        let imageData = xctp;
        
        // 如果是字符串，尝试解析为 JSON
        if (typeof xctp === 'string') {
          imageData = JSON.parse(xctp);
        }
        
        let imageUrl = null;
        
        // 如果是数组，取第一个元素
        if (Array.isArray(imageData)) {
          if (imageData.length > 0) {
            const firstItem = imageData[0];
            imageUrl = firstItem.url || firstItem.src || firstItem.path;
          }
        }
        // 如果是对象，查找可能的图片 URL 字段
        else if (typeof imageData === 'object') {
          imageUrl = imageData.url || imageData.src || imageData.path || imageData.image;
        }
        // 如果是字符串 URL，直接使用
        else if (typeof imageData === 'string') {
          imageUrl = imageData;
        }
        
        // 如果找到了图片URL，构建完整的API路径
        if (imageUrl) {
          return `${window.globalUrl.HOME_API}/admin/file/get?ossFilePath=${imageUrl}`;
        }
        
      } catch (error) {
        console.warn('解析 xctp 图片数据失败:', error);
      }
      
      // 默认返回占位图片
      return require('@/assets/imgs/21.png');
    },

    // 新增：使用 findOneByXmbh 接口获取地块卫星图片
    async getSatelliteImage(xmbh) {
      try {
        const res = await findOneByXmbh({ xmbh: xmbh });
        if (res && res.data) {
          // 根据接口返回的数据结构处理卫星图片
          // 假设返回的数据中包含图片路径字段，如 imageUrl, path, url 等
          const imageData = res.data;
          let imageUrl = null;
          
          // 根据实际接口返回的数据结构调整字段名
          if (imageData.imageUrl) {
            imageUrl = imageData.imageUrl;
          } else if (imageData.url) {
            imageUrl = imageData.url;
          } else if (imageData.path) {
            imageUrl = imageData.path;
          } else if (imageData.satelliteImage) {
            imageUrl = imageData.satelliteImage;
          }
          
          // 如果找到了卫星图片URL，构建完整的API路径
          if (imageUrl) {
            return `${window.globalUrl.HOME_API}/admin/file/get?ossFilePath=${imageUrl}`;
          }
        }
      } catch (error) {
        console.warn('获取卫星图片失败:', error);
      }
      
      // 如果获取卫星图失败，返回默认图片
      return require('@/assets/imgs/21.png');
    },

    // 增强的图片获取方法：优先使用卫星图，降级到现场图片
    async getEnhancedImage(land) {
      // 优先尝试获取卫星图片
      if (land.xmbh) {
        const satelliteImage = await this.getSatelliteImage(land.xmbh);
        // 如果获取到了有效的卫星图片（非默认图片），则使用卫星图片
        if (satelliteImage && !satelliteImage.includes('21.png')) {
          return satelliteImage;
        }
      }
      
      // 如果卫星图获取失败，降级使用现场图片
      return this.getFirstImage(land.xctp);
    },

         // 处理地块点击事件，跳转到项目详情页面
     handleLandClick(land) {
       this.$router.push({
         name: "projectDetail",
         query: {
           c: land.xmbh,
           centerPoint: land.centerPoint,
           curTab: land.cqlxbh || '02', // 使用地块的产权类型编号，默认为'02'
         },
       });
     }
  }
}
</script>

<style scoped>
/* 地块卡片列表样式 */
.land-card-list {
  width: 100% !important;
  height: 100% !important;
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-height: 400px;
  overflow-y: auto;
 /* padding: 20px;  添加适当的内边距 */
}

/*
  单个地块卡片样式
  - 默认透明边框，选中高亮
*/
.land-card {
  margin-left: 50px;
  margin-top: 10px;
  display: flex;
  align-items: center;
  border-radius: 12px;
  border: 2px solid transparent;
  box-shadow: 0 2px 8px #eee;
  padding: 12px;
  background: #fff;
  position: relative;
  transition: box-shadow 0.2s, border-color 0.2s;
  cursor: pointer;
}

.land-card.selected {
  border-color: #409eff;
  box-shadow: 0 2px 12px rgba(64, 158, 255, 0.2);
}

/* 地块图片样式 */
.land-img {
  width: 64px;
  height: 64px;
  border-radius: 8px;
  object-fit: cover;
  margin-right: 16px;
}

.land-info {
  flex: 1;
}

.land-title {
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 6px;
}

.land-tags {
  display: flex;
  gap: 8px;
  margin-bottom: 6px;
}

.land-price {
  color: #888;
  font-size: 14px;
}

.price {
  color: #ff8000;
  font-weight: bold;
  font-size: 16px;
}

/* 复选框容器绝对定位在右侧中间 */
.checkbox-container {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 2;
  padding: 8px; /* 增加点击区域 */
}

/* 复选框样式 */
.land-checkbox {
  position: relative;
}

/* 空状态样式 */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: #909399;
  text-align: center;
}

.empty-icon {
  font-size: 48px;
  margin-bottom: 16px;
  opacity: 0.6;
}

.empty-text {
  font-size: 14px;
  color: #909399;
}

/* 重置 el-dialog 的默认样式 */
::v-deep .el-dialog__body {
  padding: 0 !important;
}
</style>